import { ConfirmationModal } from "@/components/ConfirmationModal";

import { ConfirmationModalVariant } from "@/components/ConfirmationModal";
import { useConfirmationModal } from "./hooks/useConfirmationModal";
import { ConfirmExitDialogProps } from "./CustomModelsCreation/CustomParameters/types";

export const ConfirmExitDialog = ({
  isSubmitted,
  setIsSubmitted,
  setIsConfirmationModalOpen,
  isConfirmationModalOpen,
  reset,
}: ConfirmExitDialogProps) => {
  const {
    onConfirmation,
    confirmLabel,
    leaveLabel,
    confirmTitle,
    confirmDescription,
    handleClose,
  } = useConfirmationModal({
    isSubmitted,
    setIsSubmitted,
    setIsConfirmationModalOpen,
    isConfirmationModalOpen,
  });

  return (
    <ConfirmationModal
      title={confirmTitle}
      description={confirmDescription}
      isOpen={isConfirmationModalOpen}
      setIsOpen={setIsConfirmationModalOpen}
      headerVariant={ConfirmationModalVariant.warning}
      leaveButtonText={leaveLabel}
      saveButtonText={confirmLabel}
      handleOnConfirm={onConfirmation}
      handleLeave={reset}
      handleClose={handleClose}
    />
  );
};
